import React from 'react'
import { cn } from '@nextui-org/react'

type Props = {
  used: number
  total: number
  color?: string // Tailwind background class, e.g., 'bg-black'
}

export const ProgressBarLine: React.FC<Props> = ({ used, total, color = 'bg-black' }) => {
  const pct = Math.max(0, Math.min(100, total > 0 ? (used / total) * 100 : 0))

  return (
    <div
      role='progressbar'
      aria-valuemax={total}
      aria-valuenow={used}
      className='h-2 w-full rounded-full overflow-hidden'
      style={{ backgroundColor: '#EDEDED' }}
    >
      <div
        className={cn('h-full rounded-full', 'transition-[width] duration-500 ease-out')}
        style={{ width: `${pct}%`, backgroundColor: color }}
      />
    </div>
  )
}
